// shared-lib/cabinet-runs/runSource.js
//
// The two provenance predicates, in one leaf module so the server, the web
// and `materializeRun` all read a run's origin the same way. `run.source` is
// provenance ONLY — what a solve DOES with a run is written in
// `resolvePolicy.js`, never derived from `source` at the call site.
//
// Pure. No I/O.
'use strict';

/**
 * A run generated by Phase B (tagged `source:'auto'`). Provenance only: every
 * run — generated, scanned or hand-drawn — now resolves its segments through
 * the ONE room-wall resolver (`buildSegmentWallResolver`, spec §8), so
 * `source` no longer selects an id space. This flag gates the things only a
 * generated kitchen has: `layoutProvenance` stamping and the `userEdited` flag
 * the regen-merge policy reads. */
function isAutoRun(run) {
  return run?.source === 'auto';
}

/**
 * A run DERIVED from geometry someone else emitted — the Phase B generator
 * (`source:'auto'`) or a scanned kitchen (`source:'scan'`, derived by
 * `processStructure`). Both live in the room-wall / cabinetWall id space
 * and so resolve through `resolveCabinetWall`; both own their bays + countertops
 * and leave appliances and corner units to whoever emitted them.
 *
 * Distinct from `isAutoRun`, which means specifically "generated by Phase B" and
 * gates the things only a generated kitchen has: `layoutProvenance` stamping and
 * the `userEdited` flag the regen-merge policy reads.
 */
function isDerivedRun(run) {
  return run?.source === 'auto' || run?.source === 'scan';
}

/**
 * A run `processStructure` derived from the scan (`source:'scan'`) — the
 * kitchen AS SCANNED. Edited or not: `userEdited` records that someone
 * re-solved it, not that it stopped being the scan's.
 */
function isScanRun(run) {
  return run?.source === 'scan';
}

module.exports = { isAutoRun, isDerivedRun, isScanRun };
